import {makeStyles} from "@material-ui/core";

export default function css() {

    return makeStyles(theme => ({
        root: {
            width: '100%',
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[5],
            padding: 20,
        },
        lb_arquivo: {
            cursor: 'pointer'
        },
        input: {
            display: 'none',
        },
    }));

}